// import the react components
import React from "react";
import {useStateContext} from "./../../context/";
import { gradient_primary } from "../../assets/data/colors";

// import the rechapta
import ReCAPTCHA from "react-google-recaptcha";

// the form action functional based component
const FormAction = ({action = "submit", text}) => {
    const {is_disable} = useStateContext();

    //return to the component data
    return (
        <div className="max-w-md">
            <ReCAPTCHA sitekey={process.env.REACT_APP_SECRET_KEY} size="invisible" />
            <button
                type={action}
                className="capitalize tracking-wider group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white hover:opacity-90 focus:outline-none focus:ring-0 mt-10 disabled:opacity-50"
                disabled={is_disable}
                style={{background: gradient_primary}}
            >
                {text}
            </button>
        </div>
    );
};
export default FormAction;